import { render, staticRenderFns } from "./Attempt.vue?vue&type=template&id=770dfcce&lang=pug&"
import script from "./Attempt.vue?vue&type=script&lang=js&"
export * from "./Attempt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports